<template>
  <b-modal id="manager-create-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow" no-close-on-backdrop>
    <template #modal-title>
      <div class="d-flex">
        <span class="modal-title adp-h2 adp-h2__modal">
          {{ managerType === 'managers' ? $t('admin.new_manager') : $t('admin.new_functional_manager') }}
        </span>
      </div>
    </template>

    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template v-if="!isLoading">
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('admin.fio') }}</label>
        <input type="text" v-model="fullname" class="adp-input adp-input__text" @input="searchEmployees">
        <div class="adp-modal-row-search" v-if="searchedEmployees.length > 0">
          <div v-for="employee in searchedEmployees" class="adp-modal-row-search__item">
            <span class="pl-3" @click="checkEmployee(employee)">{{ employee.fio }}</span>
          </div>
        </div>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('admin.company') }}</label>
        <v-select :options="companyOptions" :clearable="false" v-model="company" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('admin.department') }}</label>
        <v-select :options="departmentOptions" :clearable="false" v-model="department" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('admin.employees') }}</label>
        <v-select multiple :options="subordinatesList" v-model="subordinates" />
      </div>
    </template>
    <template #modal-footer>
      <button id="save" class="btn btn-primary adp-btn adp-btn__large" style="margin-left: auto" @click="create()">
        {{ $t('voc.save') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import api from "../../api";

export default {
  name: "ManagerCreateModal",
  components: {
  },
  props: {
    managerType: {
      type: String,
      required: true,
    }
  },
  data: function () {
    return {
      isLoading: false,

      pernumber: null,
      fullname: null,
      company: null,
      department: null,

      companyOptions: [],
      departmentOptions: [],

      employeesList: [],
      searchedEmployees: [],

      subordinatesList: [],
      subordinates: [],
    }
  },
  watch: {
    fullname(newVal) {
      if (newVal.length > 12) this.searchedEmployees = [];
    },
    company(newVal) {
      this.department = null;
      this.departmentOptions = window.IDP.departmens
        .filter(x => x.company_id === newVal)
        .map(x => ({code: x.id, label: x.name}));
    },
    department(newVal) {
      this.subordinates = [];
      this.subordinatesList = this.employeesList.filter(x => x.department_id === newVal).map(x => ({code: x.pernumber, label: x.fio}));
    },
  },
  methods: {
    async onShow() {
      this.isLoading = true;

      this.fullname = null;
      this.company = null;
      this.department = null;
      this.companyOptions = Object.keys(window.IDP.companies).map(x => ({code: window.IDP.companies[x], label: x}));

      await this.getEmployees();

      this.isLoading = false;
    },
    async getEmployees() {
      try {
        let res = await api.getEmployeesFio();
        this.employeesList = res.data;
      } catch (e) {
        console.log(e);
      }
    },
    async searchEmployees() {
      if (this.fullname.length > 2) {
        this.searchedEmployees = this.employeesList.filter(item => item.fio.toLowerCase().includes(this.fullname.toLowerCase()));
      } else {
        this.searchedEmployees = [];
      }
    },
    checkEmployee(employee) {
      this.fullname = employee.fio;
      this.pernumber = employee.pernumber;
    },
    async create() {
      const data = {
        'pernumber': String(this.pernumber),
        'company': this.company,
        'department': this.department,
        'subordinates': this.subordinates.map(x => x.code),
      }

      try {
        let resp = null;
        if (this.managerType === 'managers') resp = await api.createManager(data);
        if (this.managerType === 'functional_managers') resp = await api.createFunctionalManager(data);
        if (resp && resp.status === 200) {
          this.$bvModal.hide('manager-create-modal');
          this.$emit('manager-created');
        }
      } catch (e) {
        console.error(e.response.data);
        this.$toasts.error(JSON.stringify(e.response.data, null, 2), {
          duration: 700000,
        });
      }
    },
  },
  async mounted() {
    await this.getEmployees();
  }
}
</script>
<style scoped>
.vs--searchable .vs__dropdown-toggle {
  height: auto;
}
</style>
